import { useEffect, useState } from 'react';

import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { GATEWAY_PAYMENT_TOKEN, SALE_ID } from '../../../config/cacheKey';
import LayoutWithoutDrawer from '../../../layouts/LayoutWithoutDrawer';
import { IGetWaitForCustomerApproveSalesResponse } from '../../../models/sale.model';
import { GetWaitForCustomerApproveSales } from '../../../services/sale.service';
import { GetTotalBalance } from '../../../services/wallet.service';
import Notifications from '../../notification/notifications';
import OngoingDetailPurchase from '../../purchase/ongoingDetailPurchase';
import OngoingPurchases from '../../purchase/ongoingPurchases';
import Payment from '../../requestSteps/inquiryFee/resultPayment/payment';
import GuarantorFile from './guarantor/detail/guarantorFile';
import GurantorDetail from './guarantor/detail/gurantorDetail';
import Guarantor from './guarantor/guarantor';
import HomeMenu from './homeMenu';
import NewPayment from './newPayment/newPayment';
import PurchaseRecordDetail from './purchaseRecords/purchaseRecordDetial';
import PurchaseRecords from './purchaseRecords/purchaseRecords';
import TradeContainer from './trade/tradeContainer';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';


const HomeMenuContainer = ({ setTabChild }: { setTabChild: (id: number) => void }) => {
    const navigate = useNavigate();
    const [updateOngoingPurchasesState, setUpdateOngoingPurchasesState] = useState<boolean>(false);
    const [totalBalance, setTotalBalance] = useState<number>();


    const queryClient = useQueryClient();

    const [waitingSales, setWaitingSales] = useState<IGetWaitForCustomerApproveSalesResponse[]>();

    const { mutateAsync: GetTotalBalanceMutate } = useMutation(GetTotalBalance, {
        onSuccess: (data) => {
            setTotalBalance(data)
        }
    })
    const dispatch = useDispatch();
    useEffect(() => {
        const path = window.location.hash;
        const newPath = window.location.href;
        const newCleanUrl = `${window.location.origin}/#/`;
        const urlParams = new URLSearchParams(window.location.search);
        const saleKey = path.split('/')[2];

        if (newPath.includes("receiptPayment")) {
            const token = urlParams.get('t');

            localStorage.setItem(GATEWAY_PAYMENT_TOKEN, token!)
            navigate('/credit/receiptPayment', { replace: true });
        }

        //trade

        // const target = urlParams.get('target');
        // if (target && target?.includes("trade")) {

        //     setState('trade');
        //     window.history.replaceState(null, '', newCleanUrl);
        // }
        //trade

        if (path.toLowerCase().includes("/ongoingdetailpurchase/") && saleKey != null && saleKey != "") {
            navigate(`/credit/ongoingDetailPurchase/${saleKey}`, { replace: true });
            const newPath = `${window.location.protocol}//${window.location.host}`;

            queryClient.setQueryData(SALE_ID, saleKey);

            window.history.replaceState(null, '', newPath);
        }

        GetTotalBalanceMutate();
        GetWaitForCustomerApproveSalesMutate();

    }, []);
    useEffect(() => {
        if (updateOngoingPurchasesState) {
            GetWaitForCustomerApproveSalesMutate();
            setUpdateOngoingPurchasesState(false)
        }
    }, [updateOngoingPurchasesState]);


    const { mutate: GetWaitForCustomerApproveSalesMutate } = useMutation(GetWaitForCustomerApproveSales, {
        onSuccess: (data: IGetWaitForCustomerApproveSalesResponse[]) => {

            if (data != null && data.length > 0) {
                setWaitingSales(data)
            }
        }
    });


    const setState = (state: string) => navigate(`/credit/${state === 'home' ? '' : state === 'garantour' ? 'guarantors' : state}`);
    return (
        <div >
            <Routes>
                <Route index element={<HomeMenu setState={setState} setTabChild={setTabChild} totalBalance={totalBalance} waitingPurchases={waitingSales} />} />
                <Route path="guarantors" element={<Guarantor setState={setState} />} />
                <Route path="guarantorDetail" element={<GurantorDetail setState={setState} />} />
                <Route path="guarantorFile" element={<GuarantorFile setState={setState} />} />
                <Route path="purchaseRecords" element={<PurchaseRecords setState={setState} setTabChild={setTabChild} />} />
                <Route path="purchaseRecordDetail" element={<PurchaseRecordDetail />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="ongoingPurchases" element={<OngoingPurchases waitingPurchases={waitingSales!} setState={setState} setTabChild={setTabChild} />} />
                <Route path="ongoingDetailPurchase/:key?" element={<OngoingDetailPurchase ongoingPurchases={waitingSales?.length || 0} setWaitingSales={setWaitingSales} setState={setState} />} />
                <Route path="newPayment" element={<NewPayment setState={setState} />} />
                <Route path="receiptPayment" element={<LayoutWithoutDrawer><Payment parentRoute='home' /></LayoutWithoutDrawer>} />
                <Route path="trade/*" element={<TradeContainer setTabChild={setTabChild} />} />
                <Route path="*" element={<Navigate to="/credit" replace />} />
            </Routes>
        </div>
    )
}

export default HomeMenuContainer
